<p-accordion #report [multiple]="true">
  <p-accordionTab [selected]="true" [cache]="false">
    <ng-template pTemplate="header">
      <h5>Сводный отчет</h5>
    </ng-template>
    <div class="fluid formgrid grid" *ngIf="datasource" appStopAccordionHomeEnd>
      <div class="field col-1 xl:col-1 sm:col-4">
        <label for="DD" class="do-not-wrap-text">Начало периода</label>
        <p-calendar id="DD" dateFormat="dd.mm.yy" [(ngModel)]="dateFrom" (onSelect)="onDateFromSelect($event)" (onInput)="onDateFromInput($event)"
                    showButtonBar="true" selectOtherMonths="true" firstDayOfWeek="1"></p-calendar>
      </div>
      <div class="field col-1 xl:col-1 sm:col-4">
        <label for="DV" class="do-not-wrap-text">Конец периода</label>
        <p-calendar id="DV" dateFormat="dd.mm.yy" [(ngModel)]="dateTo" [minDate]="dateFrom" (onSelect)="onDateToSelect($event)" (onInput)="onDateToInput($event)"
                    showButtonBar="true" selectOtherMonths="true" firstDayOfWeek="1"></p-calendar>
      </div>
      <div class="field col-1 xl:col-1 sm:col-4">
        <label for="PR" class="do-not-wrap-text">Период</label>
        <p-dropdown #PR if="PR" [options]="periods" [(ngModel)]="selectedPeriod" (onChange)="onPeriodChange($event)" optionLabel="name" optionValue="code"></p-dropdown>
      </div>

      <div class="field col-2 xl:col-2 sm:col-6">
        <app-currencyselector #cs1 labelKey="Валюта" [selectedID]="currency" [_currencyDate]="dateTo" (SelectedCurrency)="onCurrencySelection($event)"></app-currencyselector>
      </div>

      <div #DDN class="field col-1 xl:col-1 sm:col-6">
        <label for="DN" class="do-not-wrap-text">Разделитель</label>
        <input id="DN" type="number" pInputText [(ngModel)]="divider" step="1" [min]="1" [max]="100" style="text-align: right" (change)="onDividerChange($event)" />
      </div>

      <div class="field col-4 xl:col-6 sm:col-12">
        <label for="DC" class="do-not-wrap-text">Покупатели</label>
        <p-multiSelect #DC [options]="customers" placeholder="Покупатели" (onChange)="onCustomerChange($event)"
                       [(ngModel)]="selectedCustomers"
                       styleClass="p-column-filter p-dropdown-filter-style"
                       optionLabel="CLIENTSNIKNAME" maxSelectedLabels="3" dataKey="CLIID">

          <ng-template let-customer pTemplate="item">

            <ng-template #t [ngTemplateOutlet]="t" let-ci [ngTemplateOutletContext]="{ $implicit: getCustomerIndex(customer) }">
              <div class="col-8">{{customer.CLIENTSNIKNAME}}</div>
              <div class="col-2 do-not-wrap-text-ra"><span *ngIf="ci">{{ci | number:'1.0-0'}}</span>&nbsp;</div>
              <div class="col-2 do-not-wrap-text-ra" [class.above-divider]="ci > divider" [class.below-divider]="ci < divider">{{customer.overallSalesVolume | number:'1.1-1'}}&nbsp;</div>
            </ng-template>
          </ng-template>

        </p-multiSelect>
      </div>

    </div>

    <div class="fluid grid" *ngIf="salesData.length else dataloading">
      <div class="p-flex-row col-12">
        <p-chart type="bar" [data]="annualSalesData" [options]="annualSalesOptions" [plugins]="plugins" (onDataSelect)="selectData($event)" width="100%" height="30rem"></p-chart>
      </div>
    </div>

    <ng-template #dataloading>
      <p-progressSpinner></p-progressSpinner>
    </ng-template>
  </p-accordionTab>

  <p-accordionTab [selected]="false" [cache]="false" [disabled]="!salesData.length">
    <ng-template pTemplate="header">
      <h5>Итоговая таблица</h5>
    </ng-template>
    <p-toolbar styleClass="">
      <ng-template pTemplate="left">
      </ng-template>

      <ng-template pTemplate="right">
        <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadSalesDataTable($event)"
                  pTooltip="Обновить таблицу" tooltipPosition="top"></p-button>

        <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportSalesData()"
                  pTooltip="Экспортировать список документов" tooltipPosition="top" [disabled]="!salesData.length"></p-button>
      </ng-template>
    </p-toolbar>
    <div *ngIf="salesData as sdcontent else cloading" appStopAccordionHomeEnd>
      <p-table id="salesDataTable" #salesDataTable
               [value]="sdcontent"
               [resizableColumns]="true"
               selectionMode="single"
               sortField="DATEFROM"
               [rows]="10"
               [paginator]="true"
               [showCurrentPageReport]="true"
               [rowsPerPageOptions]="[10,25,50,100]"
               [totalRecords]="salesData.length"
               currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
               styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="CLIENTSNIKNAME" pResizableColumn style="width: 30%">Покупатель <p-sortIcon field="CLIENTSNIKNAME"></p-sortIcon></th>
            <th pSortableColumn="CLIENTSNAME" pResizableColumn style="width: auto">Полное название <p-sortIcon field="CLIENTSNAME"></p-sortIcon></th>
            <th pSortableColumn="DATEFROM" pResizableColumn style="width: 10rem">Начало <p-sortIcon field="DATEFROM"></p-sortIcon></th>
            <th pSortableColumn="DATETO" pResizableColumn style="width: 10rem">Конец <p-sortIcon field="DATETO"></p-sortIcon></th>
            <th pSortableColumn="SALESAMOUNT" pResizableColumn style="width: 10rem">Продажи <p-sortIcon field="SALESAMOUNT"></p-sortIcon></th>
            <th pSortableColumn="PAYMENTS" pResizableColumn style="width: 8rem">Платежи <p-sortIcon field="PAYMENTS"></p-sortIcon></th>
          </tr>
          <tr>
            <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['CLIENTSNIKNAME']" (input)="salesDataTable.filter($event.target.value, 'CLIENTSNIKNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
            <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['CLIENTSNAME']" (input)="salesDataTable.filter($event.target.value, 'CLIENTSNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
            <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DATEFROM']" (input)="salesDataTable.filter($event.target.value, 'DATEFROM', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
            <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DATETO']" (input)="salesDataTable.filter($event.target.value, 'DATETO', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
            <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['SALESAMOUNT']" (input)="salesDataTable.filter($event.target.value, 'SALESAMOUNT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
            <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['PAYMENTS']" (input)="salesDataTable.filter($event.target.value, 'PAYMENTS', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-sdcontent let-expanded="expanded">
          <tr [ngSwitch]="selectedDocType" [pSelectableRow]="sdcontent">
            <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              <a [routerLink]="['/edit-client', sdcontent.CLIID]">{{sdcontent.CLIENTSNIKNAME}}</a>
            </td>
            <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{sdcontent.CLIENTSNAME}}</td>
            <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{sdcontent.DATEFROM | date:'dd.MM.yyyy'}}</td>
            <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{sdcontent.DATETO | date:'dd.MM.yyyy'}}</td>

            <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{sdcontent.SALESAMOUNT | number:'1.2-2' }}</td>
            <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{sdcontent.PAYMENTS | number:'1.0-2' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">Нет записей....</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <ng-template #cloading>
      <p>Содержимое загружается...</p>
    </ng-template>
  </p-accordionTab>
  <p-accordionTab header="Исходные данные" [selected]="false" [cache]="false" [disabled]="!datasource.length">
  </p-accordionTab>
</p-accordion>
